/* eslint-disable no-return-await */
/* eslint-disable no-useless-constructor */
import axios from 'axios';

import { BaseService } from 'core/services/base.abstract.service';
import { ActivitySessionModel } from 'core/models/activitySession.model';
import { StatusCodes } from 'http-status-codes';

export class ActivitySessionService extends BaseService {
  constructor(env) {
    super(env);
  }

  getActivitySession = async (activitySessionId) => {
    if (process.env.REACT_APP_MODE_VAR === 'standalone') {
      return new ActivitySessionModel({ activity: standalone });
    }

    return await axios
      .get(`${this.apiUrl}/api/activitysessions/${activitySessionId}`, {
        headers: this.authorization,
      })
      .then(async (res) => {
        const bo = await res?.data;
        if (res.status === StatusCodes.OK) {
          return new ActivitySessionModel(bo);
        }
        throw new Error(bo.error);
      });
  };
  getActivityOpenSession = async (activitySessionId) => {
    if (process.env.REACT_APP_MODE_VAR === 'standalone') {
      return new ActivitySessionModel({ activity: standalone });
    }
    return await axios
      .get(`${this.apiUrl}/api/activitysessions/${activitySessionId}`)
      .then(async (res) => {
        const bo = await res?.data;
        if (res.status === StatusCodes.OK) {
          return new ActivitySessionModel(bo);
        }
        throw new Error(bo.error);
      });
  };

  restartActivitySession = (activitySession) => {
    let url = `${this.orchardUrl}/go?appType=WEB_APP&restartIfCompleted=true`;

    if (
      activitySession.workingSessionId &&
      activitySession.workingSessionId !==
        '00000000-0000-0000-0000-000000000000'
    ) {
      url += `&groupSessionId=${activitySession.workingSessionId}`;
      if (activitySession.pseudo) {
        url += `&pseudo=${activitySession.pseudo}`;
      }
    } else {
      url += `&activityId=${activitySession.activity.id}`;
      if (activitySession.courseSessionId) {
        url += `&courseSessionId=${activitySession.courseSessionId}`;
      }
    }

    window.location.href = url;
  };
}
